document.addEventListener('DOMContentLoaded', function() {
    function adjustHeadings() {
      const desktopTitle = document.querySelector('.desktop-title');
      const mobileTitle = document.querySelector('.mobile-title');

      if (window.innerWidth <= 767) {
        if (desktopTitle) desktopTitle.outerHTML = '<p class="desktop-title s-main-product__title d-none d-md-block h5 md-h4 mt-p5 mb-p20">' + desktopTitle.innerHTML + '</p>';
        if (mobileTitle) mobileTitle.outerHTML = '<h1 class="mobile-title s-main-product__title h5 md-h4 mt-p5 mb-p20">' + mobileTitle.innerHTML + '</h1>';
      } else {
        if (desktopTitle) desktopTitle.outerHTML = '<h1 class="desktop-title s-main-product__title d-none d-md-block h5 md-h4 mt-p5 mb-p20">' + desktopTitle.innerHTML + '</h1>';
        if (mobileTitle) mobileTitle.outerHTML = '<p class="mobile-title s-main-product__title h5 md-h4 mt-p5 mb-p20">' + mobileTitle.innerHTML + '</p>';
      }
    }

    adjustHeadings();
    window.addEventListener('resize', adjustHeadings);
  });